import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SaldoStockService } from 'src/app/services/saldo-stock.service';
import { SecurityService } from "src/app/shared/services/security.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import * as _ from "lodash";
@Component({
  selector: 'app-modal-stock',
  templateUrl: './modal-stock.component.html',
  styleUrls: ['./modal-stock.component.scss'],
  providers: [SecurityService],
})
export class ProductoModalStockComponent implements OnInit {


  // Modales
  @ViewChild('stockProducto', { static: true }) stockProductoModal: ModalDirective;

  //Output
  @Output() onStockProducto: EventEmitter<number> = new EventEmitter<number>()

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  listaMovimientos: Array<any> = null;
  loading: boolean = false
  totales: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private saldoStockServise: SaldoStockService,
    private clog: ConsoleService,
  ) {
    this.log = this.clog.log('IMPRIMIR FACTURA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
  }

  loadAndShow(data) {
    this.ObtenerStockProducto(data)
    this.stockProductoModal.show()
  }

  ObtenerStockProducto(data) {
    this.loading = true
    this.listaMovimientos = null
    this.FetchObtenerStockProducto(data, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta
      this.listaMovimientos = registros
      this.loading = false
      this.calculateTotal()
    })
  }

  //Obtener totales de documento
  FetchObtenerStockProducto(data, callback: Function) {
    //this.log('FetchObtenerTotales this.dataCabecera', this.dataCabecera)
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        producto_codigo: data.codigo,
      }
    }
    this.log('inputParams', JSON.stringify(inputParams))
    this.saldoStockServise.obtenerStockProducto(inputParams, callback)
  }
  calculateTotal() {
    this.totales = {
      total: _.sumBy(this.listaMovimientos, 'stock_disponible'),
    }
  }
}
